import { auth } from "@/config/firebase";
import { User as FirebaseUser } from "firebase/auth";
import { useEffect, useRef } from "react";
import router from "@/router";
import useUser from "@/context/user";
import { setCurrentUser } from "@/utils/helpers";

const useLoadApp = () => {
    const logout = useUser(state => state.logout);
    const authenticated = useUser(state => state.authenticated);

    const unsubscribe = useRef<() => void>();

    const path = router.state.location.pathname;
    const isAuthRoute = path === "/sign-in" || path === "/reset-password";

    const onAuthStateChanged = async (auth: FirebaseUser | null) => {
        try {
            unsubscribe.current?.();

            if (!auth && isAuthRoute) return;

            if (!auth && authenticated) logout();
            if (!auth) return router.navigate("/sign-in");

            await setCurrentUser(auth);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        const sub = auth.onAuthStateChanged(onAuthStateChanged);
        unsubscribe.current = sub;
    }, []);
};

export default useLoadApp;
